





































































































































import Vue from 'vue'
import Component from "vue-class-component"
import { getCategories, getCategory, getProducts, getSizes } from '@/utils/customerApi'
import { Prop, Watch } from "vue-property-decorator"
import Category, { emptyCategory } from '@/models/category'
import { perPageOptions } from "@/utils/vendor/constants"
import ProductsSetPopover from "@/components/products/ProductsSetPopover.vue"
import ProductPrice from "@/components/products/ProductPrice.vue"
import BluredBackground from './BluredBackground.vue'
import CategoriesData from '@/models/categoriesData'
import Product from '@/models/product'
import ProductSize from '@/models/productSize'
import { shopPath } from '@/utils/shop'
import ProductsData from '@/models/productsData'
import { customer } from "@/store"
import { productThumbUrl } from '@/utils/functions'
const moment = require('moment')
import axios, { CancelTokenSource } from 'axios'

@Component({
  components: {
    ProductsSetPopover,
    ProductPrice,
    BluredBackground
  }
})
export default class Gallery extends Vue {
  @Prop() publicUrl!: string
  @Prop() categoryId!: number
  
  category: Category | null = null
  categories: Array<Category> = []
  subcategories: Array<Category> = []
  subcategoriesData!: CategoriesData
  searchQuery = ""
  sizes: Array<string> = []
  sizeTitle = ""

  loading = true
  productsData?: ProductsData 
  productId: number | null = null
  currentPage = 1
  perPageOptions = perPageOptions
  productThumbUrl = productThumbUrl

  cancelToken?: CancelTokenSource

  tableFields = [ 
    { key: 'image', label: '' },
    { key: 'title', label: this.$t('Название') },
    { key: 'sku', label: this.$t('Артикул') },
    { key: 'price', label: this.$t('Цена'), variant: 'warning' },
    { key: 'availability', label: this.$t('Наличие') },
    { key: 'info', label: '' },
  ]

  translate(str: string) {
    return this.$t(str) as string
  }

  get retailerPage() {
    return customer.retailerPage
  }

  get moment() {
    return moment
  }

  get customer() {
    return customer
  }

  async setProductsDisplayMode(value: string) {
    customer.setProductsDisplayMode(value)
    await this.getProducts()
  }

  // «В наличии» здесь то же, что у фильтра и у «Показывать только товары в
  // наличии»: остаток, предзаказ или «Доступен всегда» (availableDropshipper)
  isSelectedSize(size: ProductSize) {
    return !!this.sizeTitle && size.title == this.sizeTitle && size.availableDropshipper
  }

  // выбранный в фильтре размер — жёлтой строкой поверх подсветки наличия:
  // по ней сразу видно, что нашлось именно то, что искали
  sizeCellColor(size: ProductSize) {
    if (this.isSelectedSize(size)) {
      return 'table-warning'
    }
    return size.availableDropshipper && this.retailerPage && this.retailerPage.highlightAvailability
      ? `table-${this.retailerPage.buttonsColor}` : ''
  }

  realCountDropshipper(product: Product, size: ProductSize) {
    var realCountDropshipper = size.realCountDropshipper
    if (this.retailerPage && (this.retailerPage.hiddenStock || product.hiddenStock)) {
      if (realCountDropshipper && realCountDropshipper > 0) {
        return this.retailerPage.stockAvailableText
      } else {
        return this.retailerPage.stockUnavailableText
      }
    } else {
      return realCountDropshipper
    }
  }

  // мультиселект сбрасывает выбор в null, а фильтр по сети уходит строкой
  get selectedSize() {
    return this.sizeTitle || null
  }

  set selectedSize(value: string | null) {
    this.sizeTitle = value || ""
  }

  get noProductsText() {
    if (this.category) {
      if (this.category.id != -1) {
        return this.$t("Нет товаров в этой категории")
      } else if (this.searchQuery || this.sizeTitle) {
        return this.$t("Не найдено")
      }
    }
    return this.$t("Нет товаров")
  }

  get noProductsIcon() {
    if (this.searchQuery || this.sizeTitle) {
      return "search"
    } else {
      return "box-open"
    }
  }

  @Watch('searchQuery')
  @Watch('sizeTitle')
  async watchSearchQuery() {
    this.currentPage = 1
    await this.getProducts()
  }

  async currentPageChanged(page: number) {
    this.currentPage = page
    await this.getProducts()
    window.scrollTo(0,0)
  }

  async setPerPageOption(perPage: number) {
    customer.setProductsPerPage(perPage)
    this.currentPage = 1
    await this.getProducts()
  }

  openProduct(productId: number) {
    this.$router.push(this.productLink(productId))
  }

  productLink(productId: number) {
    return shopPath(`/p/${productId}`)
  }

  async setCategory(category: Category, getProducts: boolean = true) {
    if (category.id !== undefined) {
      this.category = category
    }
    this.$router.push(shopPath(`/c/${category.id}`))
    if (getProducts)
      await this.getProducts()
  }

  async filterChanged() {
    await this.getProducts()
  }

  openSubcategory(categoryId: number) {
    if (categoryId == -1) {
      this.$router.push(shopPath())
    } else {
      this.$router.push(shopPath(`/c/${categoryId}`))
    }
    window.scrollTo(0,0)
  }

  async mounted() {
    var allCategory = emptyCategory()
    allCategory.id = -1
    allCategory.title = this.translate("Все категории")

    var noCategory = emptyCategory()
    noCategory.id = 0
    noCategory.title = this.translate("Без категории")

    // товарам хватает категории из адреса: названия для хлебных крошек,
    // подкатегории и вариации для фильтра им не нужны, а по очереди это
    // три лишних ожидания перед первым товаром
    var inCategory = this.categoryId > 0
    var currentId = inCategory ? this.categoryId : (this.categoryId == 0 ? 0 : -1)
    var categoryRequest = inCategory ? getCategory(this.publicUrl, this.categoryId) : null
    var subcategoriesRequest = inCategory ? getCategories(this.publicUrl, this.categoryId) : null
    // фильтр не обязателен: не загрузились вариации — список работает без него
    var sizes = getSizes(this.publicUrl, currentId).catch(() => [] as Array<string>)
    var products = this.getProducts(currentId)

    if (categoryRequest) {
      await this.setCategory(await categoryRequest, false)
    } else if (this.categoryId == 0) {
      await this.setCategory(noCategory, false)
    }
    if (!this.category) {
      await this.setCategory(allCategory, false)
    }
    if (subcategoriesRequest) {
      this.subcategoriesData = await subcategoriesRequest
      this.subcategories = this.subcategoriesData.results
    }
    await products
    // 36, 36.5, 37 … 40 по числу, а не по алфавиту
    // ponytail: буквенные S/M/L идут по алфавиту (L, M, S); порядок одежды — если попросят
    this.sizes = (await sizes).sort((a, b) => a.localeCompare(b, undefined, { numeric: true }))
  }

  get breadcrumbItems() {
    var _breadcrumbItems = []
    if (this.category) {
      var parent: any = this.category
      while(parent) {
        _breadcrumbItems.unshift(parent)
        parent = parent.parent
      }
    }
    return _breadcrumbItems
  }

  deleteProductModal(productId: number) {
    this.productId = productId
  }

  // categoryId передают только при первой загрузке: там категория ещё не
  // пришла с сервера, а её id уже известен из адреса
  async getProducts(categoryId?: number) {
    this.loading = true
    var id = categoryId !== undefined ? categoryId
      : (this.category && this.category.id !== undefined ? this.category.id : undefined)
    if (id !== undefined) {
      if (this.cancelToken)
        this.cancelToken.cancel()

      this.cancelToken = axios.CancelToken.source()

      this.productsData = await getProducts(
        this.publicUrl, this.currentPage, customer.productsPerPage, 
        id, this.searchQuery, this.sizeTitle,
        customer.productsDisplayMode, this.cancelToken.token
      )
    }
    this.loading = false
  }
}
